import { css, html, LitElement } from 'lit-element';
import { pxToRem } from 'lm-ui-kit/src/utils/css-utils';
import { screenLgMin, screenSmMin } from 'lm-ui-kit/src/utils/response-query';

export class UcFooterApps extends LitElement {
  static get styles() {
    return css`
      :host {
        display: grid;
        align-items: center;
        grid-gap: ${pxToRem(8)};
        grid-template-columns: 1fr 1fr;
      }

      @media (min-width: ${screenSmMin}px) and (max-width: ${screenLgMin}px) {
        :host {
          height: 100%;
          grid-template-columns: 1fr;
        }
      }
    `;
  }

  render() {
    return html` <slot></slot> `;
  }
}
